import styled from 'styled-components';
import { Text } from '@rsos/base-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { UNITE_RADIOS_PANE_WIDTH } from '../../../constants/dataComponentsDimensions';

const NAVIGATION_HEIGHT = 52; // the nav at the top of the screen
export const EVENT_PANE_MARGIN = 16;

export const StyledTimestamp = styled(Text).attrs({
  fontWeight: 'regular',
  size: 'xsmall',
  color: 'secondaryText',
  inline: false,
})`
  self-align: center;
`;

export const CloseButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const StyledRadiosPane = styled.div`
  display: flex;
  flex-direction: column;
  width: ${UNITE_RADIOS_PANE_WIDTH}px;
  flex: 0 0 auto; // Fixes clashing width issues with the map
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);
  z-index: 1; // ASC share dropdown
  background: ${props => props.theme.colors.background};

  ${({ theme }) => {
    // Apply a gradient when the EventPane is in dark(er) mode.
    if (theme.colors.name !== 'light') {
      return `
      background: linear-gradient(
        0deg,
        #0b1928 0%,
        rgba(41,54,72, 0.5) 50%,
        #0b1928 100%
      );
      backdrop-filter: blur(15px);
      `;
    } else {
      return `
      background: linear-gradient(
        0deg,
        #FFFFFF 0%,
        rgba(228, 230, 231, 0.5) 50%,
        #FFFFFF 100%
      );
      backdrop-filter: blur(15px);
      `;
    }
  }}

  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;
